const SyncType = {
  TIME_ENTRIES: "typeOfSync.timeEntries",
  SYNC_OBJECTS: "typeOfSync.syncObjects",
};

export { SyncType };
